import {motion} from "framer-motion";

const QrMenuDisabled = () => {

  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-4">
      <motion.div
        initial={{opacity: 0, y: 20}}
        animate={{opacity: 1, y: 0}}
        transition={{duration: 1, ease: [0.25, 0.8, 0.25, 1]}} // cubic bezier easing
        className="text-center"
      >
        <motion.h1
          initial={{scale: 0.95}}
          animate={{scale: 1}}
          transition={{duration: 0.8, ease: "easeOut"}}
          className="text-xl md:text-2xl font-semibold text-gray-500"
        >
          Restoranın QR Menü özelliği kapalıdır
        </motion.h1>
        <motion.p
          initial={{opacity: 0}}
          animate={{opacity: 1}}
          transition={{delay: 0.4, duration: 0.8}}
          className="mt-2 text-gray-400"
        >
          Lütfen işletme ile iletişime geçiniz ya da daha sonra tekrar deneyiniz.
        </motion.p>
      </motion.div>
    </div>
  );
};

export default QrMenuDisabled;
